import React from "react";

const Add_Round = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4229 0.603271C5.7334 0.603271 0.313477 6.02319 0.313477 12.7126C0.313477 19.4021 5.7334 24.822 12.4229 24.822C19.1123 24.822 24.5322 19.4021 24.5322 12.7126C24.5322 6.02319 19.1123 0.603271 12.4229 0.603271ZM19.4541 14.0798C19.4541 14.4021 19.1904 14.6658 18.8682 14.6658H14.376V19.158C14.376 19.4802 14.1123 19.7439 13.79 19.7439H11.0557C10.7334 19.7439 10.4697 19.4802 10.4697 19.158V14.6658H5.97754C5.65527 14.6658 5.3916 14.4021 5.3916 14.0798V11.3455C5.3916 11.0232 5.65527 10.7595 5.97754 10.7595H10.4697V6.26733C10.4697 5.94507 10.7334 5.6814 11.0557 5.6814H13.79C14.1123 5.6814 14.376 5.94507 14.376 6.26733V10.7595H18.8682C19.1904 10.7595 19.4541 11.0232 19.4541 11.3455V14.0798Z"
        fill="black"
      />
    </svg>
  );
};

export default Add_Round;
